<template>
    <div>
        <v-alert variant="tonal" type="info">
            Clique nos cards para habilitar/desabilitar
            os status de matrículas na integração
        </v-alert>
        <div class="my-2" v-for="codtipocurso, ctc in Array.from(new Set(parametros.map(p=> p.codtipocurso)))"
            :key="'codtipocurso_'+ctc">
            <div class="py-2">
                <h2 class="text-h5 text-grey"># {{codtipocurso_label(codtipocurso)}}</h2>
                <v-row v-show="tem_filial_codtipocurso(codtipocurso)" class="my-1">
                    <v-col cols="12" sm="6" md="4" lg="3"
                        v-for="param, idx_p in parametros.filter(p => p.codtipocurso === codtipocurso)"
                        :key="idx_p">
                        <loading-gdb
                            :propObject="loading == 'update-parametro-'+param.id"
                            :text="'Atualizando '+param.descricao"/>
                        <v-card
                            :title="`Habilitar/Desabilitar Status`"
                            :color="param.integrar ? 'success' : 'error'"
                            :elevation="param.integrar ? 0 : 4"
                            @click="onChangeParam(param, parametros.filter(p => p.codtipocurso === codtipocurso))"
                            >
                                <v-col cols="12" align="center" class="text-h6 overline">
                                    {{param.descricao}}
                                </v-col>
                                <v-col cols="12" align="center" class="subtitle-2">
                                    Status {{param.integrar ? '' : 'não '}} será integrado
                                </v-col>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    data: ()=>({
        parametros: [],
        loading: null
    }),
    methods: {
        ...mapActions(['GetParametroStatusMatricula', 'UpdateParametroStatusMatricula']),
        async obterParametros(){
            this.loading = 'get-parametros'
            const data = await this.GetParametroStatusMatricula()
            this.loading = null
            this.parametros = data
        },
        tem_filial_codtipocurso(codtipocurso){
            return ((this.StateAuthenticatedUser||{}).get_filiais||[]).filter(f => f.codtipocurso === codtipocurso).length > 0
        },
        codtipocurso_label(codtipocurso){
            switch (codtipocurso){
                case 1: return 'Ensino Básico';
                case 2: return 'Graduação';
                case 3: return 'Pós Graduação';
                default: return 'Cód Tipo Curso';
            }
        },
        async onChangeParam(value, lista){
            value.integrar = !value.integrar
            // formatar em lista de flags integrar
            let todos_desabilitados = lista.map(l => l.integrar)
            // retorna se todas as flasg são falsas (quer dizer que não há nenhum parâmetro selecionado)
            todos_desabilitados = todos_desabilitados.every(v => v === false)
            // Se todos estiverem desabilitados, então remarcar de volta e exibir mensagem de que haja pelo menos 1 status selecionado
            if(todos_desabilitados){
                alert('Atenção! É necessário que haja pelo menos um status para integração!')
                // remarcar de volta
                value.integrar = !value.integrar
                return
            }
            this.loading = 'update-parametro-'+value.id
            await this.UpdateParametroStatusMatricula({integrar: value.integrar, id:value.id })
            this.loading = null
        }
    },
    mounted(){
        this.obterParametros()
    },
    computed:{
        ...mapGetters(['StateAuthenticatedUser'])
    }
}
</script>